import { useTheme } from '@mui/material';

export const IntroIcon6 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                fill={primaryIconStrokeColor}
                d="M32 8c2.206 0 4 1.794 4 4v16c0 2.206-1.794 4-4 4H8c-2.206 0-4-1.794-4-4v-1.038l2 .012V28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V16.975l-11.044 8.093a5.008 5.008 0 0 1-5.912 0L6 16.975v5.535l-2-.012V12c0-2.206 1.794-4 4-4h24ZM8 10c-1.106 0-2 .894-2 2v2.494l12.225 8.962a3.002 3.002 0 0 0 3.55 0L34 14.494V12c0-1.106-.894-2-2-2H8Z"
            />
        </svg>
    );
};
